import React, { useEffect, useState } from 'react';
import { Search, ChevronDown, SlidersHorizontal } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
import { ProjectCard } from '../components/ProjectCard';
interface InventoryPageProps {
  onBack: () => void;
  onNetworkClick?: () => void;
  onRMIClick?: () => void;
  onInventoryClick?: () => void;
  onProjectClick?: (projectId: number, developerId: number, developerName: string) => void;
}
export function InventoryPage({
  onBack,
  onNetworkClick,
  onRMIClick,
  onInventoryClick,
  onProjectClick
}: InventoryPageProps) {
  const [currentSlide, setCurrentSlide] = useState(0);
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Featured projects carousel data with real images
  const featuredProjects = [{
    id: 1,
    title: 'Kattameya Plaza',
    image: 'https://cdn.magicpatterns.com/uploads/66yvcxVne9oJLHSKg1QsRp/Kattameya-Plaza-Compound-New-Cairo-Egypt-3.jpg',
    incentive: '2.5% + 1% Incentive'
  }, {
    id: 2,
    title: 'New Cairo Villas',
    image: 'https://cdn.magicpatterns.com/uploads/1LrokktWumQwKkymWs618H/OIP.jPDIFsWdYJcYE7Qv5fP83AHaE8.webp',
    incentive: '3% + 1.5% Incentive'
  }, {
    id: 3,
    title: 'Modern Residences',
    image: 'https://cdn.magicpatterns.com/uploads/pb25Q4FEBtvrAuXgfkjUrj/OIP.rK2CaW9pXB14mwMzxtBI3wHaE8.webp',
    incentive: '2% + 1% Incentive'
  }];
  const currentFeatured = featuredProjects[currentSlide];
  // Mock data for sections
  const newProjects = [{
    id: 1,
    title: 'Mountain View iCity',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80',
    logo: 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
    developerId: 1,
    developerName: 'Mountain View'
  }, {
    id: 2,
    title: 'Palm Hills New Cairo',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80',
    logo: 'https://cdn.magicpatterns.com/uploads/e3xetC89TNSJtFzKEK9GJ9/OIP.McQBqob_yPFZovOPZDod3AHaHa.webp',
    developerId: 2,
    developerName: 'Palm Hills'
  }, {
    id: 3,
    title: 'Hyde Park',
    image: 'https://images.unsplash.com/photo-1600596542815-2495db9dc2c3?w=800&q=80',
    logo: 'https://cdn.magicpatterns.com/uploads/8vQhTfMrXW8bwweERT8mA7/OIP.xWHw7TazT7rFveGb0a9zNwHaHa.webp',
    developerId: 3,
    developerName: 'Hyde Park'
  }];
  const favoriteProjects = [{
    id: 4,
    title: 'Madinety',
    image: 'https://images.unsplash.com/photo-1448630360428-65456885c650?w=800&q=80',
    developerId: 4,
    developerName: 'Talaat Moustafa Group'
  }, {
    id: 5,
    title: 'Mivida Emaar',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
    developerId: 5,
    developerName: 'Emaar Misr'
  }, {
    id: 6,
    title: 'Villette Sodic',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    developerId: 6,
    developerName: 'Sodic'
  }];
  const newCairoProjects = [{
    id: 7,
    title: 'Taj City',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
    developerId: 7,
    developerName: 'Madinet Nasr'
  }, {
    id: 8,
    title: 'Sarai',
    image: 'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=800&q=80',
    developerId: 8,
    developerName: 'Madinet Nasr'
  }, {
    id: 9,
    title: 'Bloomfields',
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80',
    developerId: 9,
    developerName: 'Tatweer Misr'
  }];
  const newCapitalProjects = [{
    id: 10,
    title: 'IL Bosco',
    image: 'https://images.unsplash.com/photo-1512915922610-182181b4a359?w=800&q=80',
    developerId: 10,
    developerName: 'Misr Italia'
  }, {
    id: 11,
    title: 'Midtown Sky',
    image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800&q=80',
    developerId: 11,
    developerName: 'Better Home'
  }, {
    id: 12,
    title: 'Scenario',
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80',
    developerId: 12,
    developerName: 'Akam Developments'
  }];
  const shroukCityProjects = [{
    id: 13,
    title: 'Sodic East',
    image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80',
    developerId: 6,
    developerName: 'Sodic'
  }, {
    id: 14,
    title: 'El Patio 5 East',
    image: 'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800&q=80',
    developerId: 13,
    developerName: 'La Vista Developments'
  }, {
    id: 15,
    title: 'Granda Life',
    image: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800&q=80',
    developerId: 14,
    developerName: 'Palm Hills'
  }];
  return <div className="min-h-screen bg-neutral-bg pb-24 font-sans w-full" data-id="element-1038">
      <div className="w-full mx-auto bg-neutral-bg min-h-screen relative" data-id="element-1039">
        {/* Featured Hero Section with Carousel */}
        <div className="px-4 pt-4 pb-6" data-id="element-1040">
          <div className="relative h-64 rounded-2xl overflow-hidden shadow-md" data-id="element-1041">
            <img src={currentFeatured.image} alt={currentFeatured.title} className="w-full h-full object-cover" data-id="element-1042" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-1043" />

            <div className="absolute bottom-6 left-6" data-id="element-1044">
              <h1 className="text-3xl font-bold text-white mb-1" data-id="element-1045">
                {currentFeatured.title}
              </h1>
              <p className="text-white/90 font-medium text-sm" data-id="element-1046">
                {currentFeatured.incentive}
              </p>
            </div>

            {/* Carousel Dots */}
            <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2" data-id="element-1047">
              {featuredProjects.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentSlide ? 'bg-white shadow-sm' : 'bg-white/50 backdrop-blur-sm hover:bg-white/70'}`} data-id="element-1048" />)}
            </div>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="px-4 mb-8" data-id="element-1049">
          {/* Search Bar */}
          <div className="relative mb-3" data-id="element-1050">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1051" />
            <input type="text" placeholder="Project or Location" className="w-full pl-11 pr-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-secondary/20 focus:border-secondary shadow-sm" data-id="element-1052" />
          </div>

          {/* Filters Row */}
          <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1" data-id="element-1053">
            <button className="flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-xs font-medium text-gray-600 whitespace-nowrap hover:border-gray-300" data-id="element-1054">
              Types <ChevronDown className="w-3.5 h-3.5 text-gray-400" data-id="element-1055" />
            </button>
            <button className="flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-xs font-medium text-gray-600 whitespace-nowrap hover:border-gray-300" data-id="element-1056">
              Price <ChevronDown className="w-3.5 h-3.5 text-gray-400" data-id="element-1057" />
            </button>
            <button className="flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-xs font-medium text-gray-600 whitespace-nowrap hover:border-gray-300" data-id="element-1058">
              Rooms <ChevronDown className="w-3.5 h-3.5 text-gray-400" data-id="element-1059" />
            </button>
            <button className="flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-xs font-medium text-gray-600 whitespace-nowrap hover:border-gray-300 ml-auto" data-id="element-1060">
              <SlidersHorizontal className="w-3.5 h-3.5" data-id="element-1061" />
              All Filters
            </button>
          </div>
        </div>

        {/* Project Categories */}
        <div className="space-y-8" data-id="element-1062">
          {/* New Project Section */}
          <section data-id="element-1063">
            <div className="flex items-center justify-between px-4 mb-3" data-id="element-1064">
              <h2 className="text-lg font-bold text-neutral-text" data-id="element-1065">
                New Project
              </h2>
            </div>
            <div className="flex gap-3 overflow-x-auto px-4 pb-4 no-scrollbar" data-id="element-1066">
              {newProjects.map(project => <ProjectCard key={project.id} {...project} onClick={() => onProjectClick && onProjectClick(project.id, project.developerId, project.developerName)} data-id="element-1067" />)}
            </div>
          </section>

          {/* Favorite Projects Section */}
          <section data-id="element-1068">
            <div className="flex items-center justify-between px-4 mb-3" data-id="element-1069">
              <h2 className="text-lg font-bold text-neutral-text" data-id="element-1070">
                Favorite Projects
              </h2>
            </div>
            <div className="flex gap-3 overflow-x-auto px-4 pb-4 no-scrollbar" data-id="element-1071">
              {favoriteProjects.map(project => <ProjectCard key={project.id} {...project} onClick={() => onProjectClick && onProjectClick(project.id, project.developerId, project.developerName)} data-id="element-1072" />)}
            </div>
          </section>

          {/* New Cairo Section */}
          <section data-id="element-1073">
            <div className="flex items-center justify-between px-4 mb-3" data-id="element-1074">
              <h2 className="text-lg font-bold text-neutral-text" data-id="element-1075">New Cairo</h2>
            </div>
            <div className="flex gap-3 overflow-x-auto px-4 pb-4 no-scrollbar" data-id="element-1076">
              {newCairoProjects.map(project => <ProjectCard key={project.id} {...project} onClick={() => onProjectClick && onProjectClick(project.id, project.developerId, project.developerName)} data-id="element-1077" />)}
            </div>
          </section>

          {/* New Capital Section */}
          <section data-id="element-1078">
            <div className="flex items-center justify-between px-4 mb-3" data-id="element-1079">
              <h2 className="text-lg font-bold text-neutral-text" data-id="element-1080">
                New Capital
              </h2>
            </div>
            <div className="flex gap-3 overflow-x-auto px-4 pb-4 no-scrollbar" data-id="element-1081">
              {newCapitalProjects.map(project => <ProjectCard key={project.id} {...project} onClick={() => onProjectClick && onProjectClick(project.id, project.developerId, project.developerName)} data-id="element-1082" />)}
            </div>
          </section>

          {/* Shrouk City Section */}
          <section data-id="element-1083">
            <div className="flex items-center justify-between px-4 mb-3" data-id="element-1084">
              <h2 className="text-lg font-bold text-neutral-text" data-id="element-1085">
                Shrouk City
              </h2>
            </div>
            <div className="flex gap-3 overflow-x-auto px-4 pb-4 no-scrollbar" data-id="element-1086">
              {shroukCityProjects.map(project => <ProjectCard key={project.id} {...project} onClick={() => onProjectClick && onProjectClick(project.id, project.developerId, project.developerName)} data-id="element-1087" />)}
            </div>
          </section>
        </div>

        <BottomNav onNetworkClick={onNetworkClick} onRMIClick={onRMIClick} onInventoryClick={onInventoryClick} activeNav="inventory" data-id="element-1088" />
      </div>
    </div>;
}